import { render, staticRenderFns } from "./ztp.vue?vue&type=template&id=40911929&scoped=true"
import script from "./ztp.vue?vue&type=script&lang=ts"
export * from "./ztp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40911929",
  null
  
)

export default component.exports